import InvestmentsView from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Investments/View';
import PlanningDataTab from './Tabs/PlanningData/View';
import { Meeting } from './Tabs/Meeting';
import ClientDetailsView from './Tabs/ClientDetails/View';
import EmailContainer from './Tabs/Email/Container';
import { Notes } from './Tabs/Notes';
import PreviousEmailsContainer from './Tabs/PreviousEmails/Container';
import SnapshotBalanceSheetView from './Tabs/SnapshotBalanceSheet/View';
import SnapshotCashFlowView from './Tabs/SnapshotCashFlow/View';
import SnapshotGoalsView from './Tabs/SnapshotGoals/View';
import SnapshotHoldingsView from './Tabs/SnapshotHoldings/View';
import TimelineView from './Tabs/Timeline/View';
import AllNotesView from './Tabs/AllNotes/View';
import ScheduledEmailsView from './Tabs/ScheduledEmails/View';
import TranscriptView from './Tabs/Transcript/TranscriptView';
import AccomplishmentsView from './Tabs/Accomplishments/View';

import OnboardingView from './Tabs/Onboarding/View';

const tabs = [
  {
    name: 'client-details',
    label: 'Client Details',
    component: ClientDetailsView,
  },
  {
    name: 'email',
    label: 'Agendas & Follow-ups',
    component: EmailContainer,
  },
  {
    name: 'notes',
    label: 'Current Note',
    component: Notes,
  },
  {
    name: 'previous-emails',
    label: 'Previous Emails',
    component: PreviousEmailsContainer,
  },
  {
    name: 'timeline',
    label: 'Timeline',
    component: TimelineView,
  },
  {
    name: 'snapshot-balance-sheet',
    label: 'Snapshot (Balance Sheet)',
    component: SnapshotBalanceSheetView,
  },
  {
    name: 'snapshot-goals',
    label: 'Snapshot (Goals)',
    component: SnapshotGoalsView,
  },
  {
    name: 'snapshot-cash-flow',
    label: 'Snapshot (Cash Flow)',
    component: SnapshotCashFlowView,
  },
  {
    name: 'snapshot-holdings',
    label: 'Snapshot (Holdings)',
    component: SnapshotHoldingsView,
  },
  {
    name: 'planning-data',
    label: 'Planning Data',
    component: PlanningDataTab,
  },
  {
    name: 'all-notes',
    label: 'All Notes',
    component: AllNotesView,
  },
  {
    name: 'scheduled-emails',
    label: 'Scheduled Emails',
    component: ScheduledEmailsView,
  },
  {
    name: 'transcript',
    label: 'Transcript',
    component: TranscriptView,
  },
  {
    name: 'investments',
    label: 'Investments',
    component: InvestmentsView,
  },
  {
    name: 'accomplishments',
    label: 'Accomplishments',
    component: AccomplishmentsView,
  },
  {
    name: 'onboarding',
    label: 'Onboarding',
    component: OnboardingView,
  },
  {
    name: 'meeting',
    label: 'Meeting',
    component: Meeting,
  },
];

export default tabs.sort((a, b) => {
  const labelA = a.label.toLowerCase();
  const labelB = b.label.toLowerCase();

  if (labelA < labelB) return -1;
  if (labelA > labelB) return 1;

  return 0;
}).reduce((acc, curr) => {
  return {
    ...acc,
    [curr.name]: curr,
  };
}, {});
